import TalentHeaderList from "./TalentHeaderList.vue"

export default function install(Vue) {
  Vue.component("TalentHeaderList", TalentHeaderList)
}
